var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property, customElement, query, state } from 'lit/decorators.js';
import styles from './day-selector.styles';
import { SgdfElement } from '../../internal/sgdf-element.js';
import { DateHelpers } from '../../helpers/dateHelpers';
import '../day-selector-item/day-selector-item.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { dateConverter } from '../../internal/date-converter';
let SgdfDaySelector = class SgdfDaySelector extends SgdfElement {
    isSelectedDate(date) {
        return !!this.selectedDate && DateHelpers.isSameDay(DateHelpers.getDateTimeFromDate(this.selectedDate), date);
    }
    connectedCallback() {
        super.connectedCallback();
        this.checkIfIsOverflow = this.checkIfIsOverflow.bind(this);
        this.updateComplete.then(() => {
            this.isOverflow = this.checkIfIsOverflow(this.days.length);
        });
    }
    checkIfIsOverflow(dateNumber) {
        const calculatedWidth = dateNumber * 50 + (dateNumber - 1) * 16;
        const width = this.container.getBoundingClientRect().width;
        return width < calculatedWidth;
    }
    scrollToSelectedDate() {
        this.updateComplete.then(() => {
            var _a;
            (_a = this.currentDayElt) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                block: 'center',
                inline: 'center',
            });
        });
    }
    render() {
        this.days = DateHelpers.getAllDatesBetweenTwoDates({
            start: this.startDate,
            end: this.endDate,
        });
        this.scrollToSelectedDate();
        return html `
            <div class="container">
                <div
                    class="left-div"
                    style=${styleMap({
            display: this.isOverflow ? 'block' : 'none',
        })}
                ></div>
                <ul
                    class=${classMap({
            list: true,
            small: this.isOverflow,
        })}
                >
                    ${this.days.map(date => html `
                            <sgdf-day-selector-item
                                class=${classMap({
            selected: this.isSelectedDate(date),
        })}
                                .date=${date.toJSDate()}
                                .selected=${this.isSelectedDate(date)}
                            ></sgdf-day-selector-item>
                        `)}
                </ul>
                <div
                    class="right-div"
                    style=${styleMap({
            display: this.isOverflow ? 'block' : 'none',
        })}
                ></div>
            </div>
        `;
    }
};
SgdfDaySelector.styles = styles;
__decorate([
    property({ converter: dateConverter })
], SgdfDaySelector.prototype, "startDate", void 0);
__decorate([
    property({ converter: dateConverter })
], SgdfDaySelector.prototype, "endDate", void 0);
__decorate([
    property({ converter: dateConverter })
], SgdfDaySelector.prototype, "selectedDate", void 0);
__decorate([
    property({ type: Boolean })
], SgdfDaySelector.prototype, "hideNext", void 0);
__decorate([
    query('.selected')
], SgdfDaySelector.prototype, "currentDayElt", void 0);
__decorate([
    query('.container')
], SgdfDaySelector.prototype, "container", void 0);
__decorate([
    state()
], SgdfDaySelector.prototype, "isOverflow", void 0);
SgdfDaySelector = __decorate([
    customElement('sgdf-day-selector')
], SgdfDaySelector);
export default SgdfDaySelector;
//# sourceMappingURL=day-selector.js.map